module.exports = __webpack_public_path__ + "static/media/kadesignb.8ab0f2bd.png";